(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2219],{

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 20466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),

/***/ 96511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start",
      function () {
        return __webpack_require__(71686);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ID": function() { return /* binding */ searchRecentListings; },
/* harmony export */   "QR": function() { return /* binding */ getCaterer; },
/* harmony export */   "Vm": function() { return /* binding */ searchCaterers; },
/* harmony export */   "qo": function() { return /* binding */ searchRecentCaterers; }
/* harmony export */ });
/* unused harmony exports searchListings, searchMostBooked, searchBestRated, searchCaterersBy */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24955);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7385);






var algoliaAppId = "NU9B0W8STM";
var algoliaSearchApiKey = "4fbffb589c274485bb9416c80a37d4f6";
if (!algoliaAppId) {
    throw new Error("Missing ENV Variable: Algolia app id");
}
if (!algoliaSearchApiKey) {
    throw new Error("Missing ENV Variable: Algolia search api key");
}
var client = algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()(algoliaAppId, algoliaSearchApiKey, {
    responsesCache: (0,_algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__/* .createInMemoryCache */ .R)(),
    requestsCache: (0,_algolia_cache_in_memory__WEBPACK_IMPORTED_MODULE_1__/* .createInMemoryCache */ .R)({
        serializable: false
    })
});
/*
 * INDEXES
 */ var INDEX_PREFIX = "production";
var catererMarketplaceIndex = createIndex("caterer_marketplace");
var listingsMarketplaceIndex = createIndex("listings_marketplace");
var numberOfOrdersIndex = createIndex("caterer_marketplace_number_of_orders_desc");
var ratingScoreIndex = createIndex("caterer_marketplace_rating_score_desc");
var catererCreatedAtSortedIndex = createIndex("caterer_marketplace_created_at_desc");
var listingsCreatedAtSortedIndex = createIndex("listings_marketplace_created_at_desc");
var getCaterer = function(id) {
    return catererMarketplaceIndex.getObject(id);
};
/*
 * SEARCH FUNCTIONS
 */ var searchRecentCaterers = createSearchHandler(catererCreatedAtSortedIndex);
var searchRecentListings = createSearchHandler(listingsCreatedAtSortedIndex);
var searchCaterers = createSearchHandler(catererMarketplaceIndex);
var searchListings = createSearchHandler(listingsMarketplaceIndex);
var searchMostBooked = createSearchHandler(numberOfOrdersIndex);
var searchBestRated = createSearchHandler(ratingScoreIndex);
var searchCaterersBy = function(_param) {
    var city = _param.city, keywords = _param.keywords, method = _param.method, searchOptions = _object_without_properties(_param, [
        "city",
        "keywords",
        "method"
    ]);
    var fetcher = method === "mostBooked" ? searchMostBooked : searchBestRated;
    var cityFilter = city ? {
        filters: 'cities:"'.concat(city, '"')
    } : {};
    return fetcher(keywords, _object_spread({}, cityFilter, searchOptions));
};
/*
 * UTILS
 */ function createSearchHandler(index) {
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var queryString, params, query, hits;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryString = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", params = _arguments.length > 1 ? _arguments[1] : void 0;
                    query = Array.isArray(queryString) ? queryString.join(" ") : queryString;
                    return [
                        4,
                        index.search(query, params)
                    ];
                case 1:
                    hits = _state.sent().hits;
                    return [
                        2,
                        hits
                    ];
            }
        });
    });
}
function createIndex(name) {
    return client.initIndex("".concat(INDEX_PREFIX, "_").concat(name));
}


/***/ }),

/***/ 71686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ start; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./src/lib/algolia/client.ts
var client = __webpack_require__(47817);
// EXTERNAL MODULE: ./src/qualification/schema/questions/cateringCategoriesQuestion.ts
var cateringCategoriesQuestion = __webpack_require__(61535);
// EXTERNAL MODULE: ./src/qualification/schema/questions/cityQuestion.tsx
var cityQuestion = __webpack_require__(26407);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var steps = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
;// CONCATENATED MODULE: ./src/qualification/helpers/parseSearchParams.ts










var HANDLED_QUESTION_IDS = [
    "catering_categories",
    "city",
    "event_date", 
];
var HANDLED_QUERY_PARAMS = (0,_to_consumable_array/* default */.Z)(HANDLED_QUESTION_IDS).concat([
    "selectedCatererId", 
]);
function getInitialFunnelDataFromQueryStrings() {
    return _getInitialFunnelDataFromQueryStrings.apply(this, arguments);
}
function _getInitialFunnelDataFromQueryStrings() {
    _getInitialFunnelDataFromQueryStrings = (0,_async_to_generator/* default */.Z)(function() {
        var params, city, catering_categories, event_date, selectedCatererId, leadSource, answers, cityFromLocalStorage, nonSkippableQuestions, validCateringCategories, selectedCaterer, timestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = (0,lib.parse)(window.location.search, {
                        ignoreQueryPrefix: true
                    });
                    city = params.city, catering_categories = params.catering_categories, event_date = params.event_date, selectedCatererId = params.selectedCatererId, leadSource = params.leadSource;
                    answers = {};
                    cityFromLocalStorage = (0,cities/* getCityInLocalStorage */.iZ)();
                    nonSkippableQuestions = [];
                    if (!city && cityFromLocalStorage && (0,cityQuestion/* isValidCity */.m0)(cityFromLocalStorage)) {
                        answers.city = cityFromLocalStorage;
                    }
                    if (city && (0,cityQuestion/* isValidCity */.m0)(city)) {
                        answers.city = city;
                    }
                    if (city && !(0,cityQuestion/* isValidCity */.m0)(city) || cityFromLocalStorage && !(0,cityQuestion/* isValidCity */.m0)(cityFromLocalStorage)) {
                        answers.city = "other";
                    }
                    if (Array.isArray(catering_categories)) {
                        validCateringCategories = catering_categories.filter(cateringCategoriesQuestion/* isValidCateringCategory */.kl);
                        if (validCateringCategories.length) {
                            answers.catering_categories = validCateringCategories;
                        }
                    }
                    selectedCaterer = undefined;
                    if (!(typeof selectedCatererId === "string")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,client/* getCaterer */.QR)(selectedCatererId)
                    ];
                case 1:
                    selectedCaterer = _state.sent();
                    _state.label = 2;
                case 2:
                    if (event_date && typeof event_date === "string") {
                        timestamp = parseInt(event_date, 10);
                        answers.event_date = (0,toDate/* default */.Z)(timestamp);
                        answers.has_recurring_need = false;
                        nonSkippableQuestions.push(steps/* steps.eventDateAndLeadType.id */.S6.eventDateAndLeadType.id);
                    }
                    return [
                        2,
                        {
                            answers: answers,
                            nonSkippableQuestions: nonSkippableQuestions,
                            selectedCaterer: selectedCaterer,
                            leadSource: typeof leadSource === "string" ? leadSource : undefined
                        }
                    ];
            }
        });
    });
    return _getInitialFunnelDataFromQueryStrings.apply(this, arguments);
}
function getQueryParamsWithoutAnswers() {
    var queryParams = (0,lib.parse)(window.location.search, {
        ignoreQueryPrefix: true
    });
    if (typeof queryParams === "object") {
        HANDLED_QUERY_PARAMS.forEach(function(answerKey) {
            delete queryParams[answerKey];
        });
        delete queryParams.leadSource;
        delete queryParams.selectedCaterer;
    }
    return queryParams;
}

;// CONCATENATED MODULE: ./src/pages/start/index.tsx









function Start() {
    var ref = (0,context/* useQualification */._8)(), actions = ref.actions, state = ref.state;
    var router = (0,next_router.useRouter)();
    var reorder_offer_id = router.query.reorder_offer_id;
    if (reorder_offer_id && !state.reorderOfferId) {
        actions.setReorderOfferId(reorder_offer_id);
    }
    (0,react.useEffect)(function() {
        var initialize = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var variations, initializedData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            variations = [];
                            return [
                                4,
                                getInitialFunnelDataFromQueryStrings()
                            ];
                        case 1:
                            initializedData = _state.sent();
                            actions.initialize((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initializedData), {
                                variations: variations
                            }));
                            return [
                                2
                            ];
                    }
                });
            });
            return function initialize() {
                return _ref.apply(this, arguments);
            };
        }();
        actions.reset();
        initialize();
    }, []);
    (0,react.useEffect)(function handleRedirect() {
        if (state.status === model/* QUALIFICATION_STATUS.answering */.w.answering) {
            var queryParams = getQueryParamsWithoutAnswers();
            router.replace({
                pathname: router.pathname + "/" + state.qualification.step.id,
                query: queryParams
            });
        }
    }, [
        state,
        router
    ]);
    return null;
}
/* harmony default export */ var start = ((0,context/* withQualificationProvider */.qj)({
    storageKey: "__funnel",
    storage: "sessionStorage"
}, Start));


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7879,4566,8406,4254,5643,9774,2888,179], function() { return __webpack_exec__(96511); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);